export default "__VITE_ASSET__DHPTFWcS__"